<template>
  <div v-if="videoChat.GetCall" class="video-chat-overlay">
    <div id="text">
      <div class="pulse">
        <img :src="this.admin_avatar" alt="cleed_logo" />
      </div>
      <div class="call-icons">
        <ul class="call-items">
          <li id="answer" class="call-item" @click="answer()">
            <span>
              <i class="material-icons">
                call
              </i>
            </span>
          </li>
          <li id="end" class="call-item" @click="cancel()">
            <span>
              <i class="material-icons">
                call_end
              </i>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { customLogger } from "@/utils";
import specs from "@/specs";

export default {
  name: "VideoChatOverlay",
  data() {
    return {
      admin_avatar: specs._IMG_AVATAR,
    };
  },
  computed: {
    videoChat() {
      const data = this.$store.state.videoChat;
      return data;
    },
  },
  methods: {
    check_UserMedia(options) {
      return new Promise((resolve, reject) => {
        navigator.mediaDevices
          .getUserMedia(options)
          .then((stream) => {
            resolve(stream);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async answer() {
      await this.check_UserMedia({ video: true, audio: true })
        .then((stream) => {
          customLogger("answer the call");
          if (this.videoChat.remotePeerId) {
            this.videoChat.socketAddr.emit("USER_AnswerCall");
            customLogger(this.videoChat.remotePeerId);
            this.videoChat.GetCall = false;
            this.videoChat.display_video_chat = true;
            this.videoChat.stream = stream
          } else {
            customLogger("there is no remotePeerId");
          }
        })
        .catch((err) => {
          customLogger(
            err,
            "Permission denied please give access to the camera and microphone"
          );
        });
    },
    cancel() {
      this.$store
        .dispatch("CancelCall")
        .then(() => {
          customLogger("cancel the call");
        })
        .catch((err) => {
          customLogger(err);
        });
    },
  },
};
</script>
